export default __webpack_public_path__ + "static/media/4.61cc95f5.jpg";